import { gtmPushEvent } from "./gtm-api-raw";

const platform = 'TagManager';

function sendToDataLayer(eventName, eventObject = null) {
  
  if(process.env.REACT_APP_API_URL !== "https://api.textiledesignbank.com/v1/") return
  
  try {
    gtmPushEvent(eventName,eventObject);
  } catch (err) {
    getErrorWithEventName(err, eventName);
  }
}

function getErrorWithEventName(err, eventName = null) {
  console.log(`${err}`);
}

export const gtmApiHelper = {
  async search(search_term, tag_term) {
    let eventName = 'search';
    let eventObject = { 'search_term': search_term, 'tag_term' : tag_term };
    sendToDataLayer(eventName, eventObject);
  },
  async login(param) {
    let eventName = 'login';
    let eventObject = { 'method': param }
    sendToDataLayer(eventName, eventObject);
  },
  async click_gnb(param) {
    let eventName = 'click_gnb';
    let eventObject = { 'menu_name': param };
    sendToDataLayer(eventName, eventObject);
  },
  async click_fnb(param) {
    let eventName = 'click_fnb';
    let eventObject = { 'menu_name': param };
    sendToDataLayer(eventName, eventObject);
  },
  async click_sns(param) {
    let eventName = 'click_sns';
    let eventObject = { 'type': param };
    sendToDataLayer(eventName, eventObject);
  },
  async click_notice(param) {
    let eventName = 'click_notice';
    let eventObject = { 'notice_title': param };
    sendToDataLayer(eventName, eventObject);
  },
  async click_banner(param) {
    let eventName = 'click_banner';
    let eventObject = { 'banner_name' : param };
    sendToDataLayer(eventName, eventObject);
  },
  async click_design(area, main_item) {
    let eventName = 'click_design';
    let eventObject = { 'area' : area, 'main_item' : main_item };
    sendToDataLayer(eventName, eventObject);
  },
  async click_category_shop(param) {
    let eventName = 'click_category_shop';
    let eventObject = { 'category_shop' : param };
    sendToDataLayer(eventName, eventObject);
  },
  async click_top5designer(param) {
    let eventName = 'click_top5designer';
    let eventObject = { 'top5designer' : param };
    sendToDataLayer(eventName, eventObject);
  },
  async click_detail_preview(detail_item, preview_type) {
    let eventName = 'click_detail_preview';
    let eventObject = { 'detail_item' : detail_item, 'preview_type': preview_type };
    sendToDataLayer(eventName, eventObject);
  },
  async click_detail_related_designs(detail_item) {
    let eventName = 'click_detail_related_designs';
    let eventObject = { 'detail_item' : detail_item };
    sendToDataLayer(eventName, eventObject);
  },
  async click_detail_more_by_designer(detail_item) {
    let eventName = 'click_detail_more_by_designer';
    let eventObject = { 'detail_item' : detail_item };
    sendToDataLayer(eventName, eventObject);
  },
  async click_detail_share(detail_item) {
    let eventName = 'click_detail_share';
    let eventObject = { 'detail_item' : detail_item };
    sendToDataLayer(eventName, eventObject);
  },
  async click_detail_zoom(detail_item, zoom_type, val) {
    let eventName = 'click_detail_zoom';
    let eventObject = { 'detail_item' : detail_item , 'zoom_type' : zoom_type, 'val' : val}
    sendToDataLayer(eventName, eventObject);
  },
  async click_faq(faq_title) {
    let eventName = 'click_faq';
    let eventObject = { 'faq_title' : faq_title };
    sendToDataLayer(eventName, eventObject);
  },
  async click_trend_post(post_title, userType) {
    let eventName = 'click_trend_post';
    let mUserType = '';

    if(userType === 'user') {
      mUserType = 'general'
    } else {
      mUserType = 'seller'
    }

    let eventObject = { 'post_title' : post_title, 'userType' : mUserType };
    sendToDataLayer(eventName, eventObject);
  },
  async click_trend_AI_pick(trend_item) {
    let eventName = 'click_trend_AI_pick';
    let eventObject = { 'trend_item' : trend_item };
    sendToDataLayer(eventName, eventObject);
  },
  async click_follower_designer(designer_name) {
    let eventName = 'click_follower_designer';
    let eventObject = { 'designer_name' : designer_name };
    sendToDataLayer(eventName, eventObject);
  },
  async deactivate_account() {
    let eventName = 'deactivate_account';
    sendToDataLayer(eventName, null);
  },
  async submit_contact_form() {
    let eventName = 'submit_contact_form';
    sendToDataLayer(eventName, null);
  },
  async try_sign_up_step(param) {
    let eventName = `try_sign_up_${param}`;
    sendToDataLayer(eventName);
  },
  async view_item(viewData, cost) {
    let eventName = 'view_item';
    let items = [];

    items.push({
      'item_name' : viewData.product_name,
      'item_id' : viewData.product_id,
      'price' : cost,
      'item_category': viewData.product_category
    })
    let eventObject = { 'items' : items };

    sendToDataLayer(eventName, eventObject);
  },
  async add_to_cart(viewData, cost, licenseType) {
    let eventName = 'add_to_cart';
    let items = [];

    items.push({
      'item_name' : viewData.product_name,
      'item_id' : viewData.product_id,
      'price' : cost,
      'item_category': viewData.product_category,
      'item_variant' : licenseType,
      'quantity' : 1
    });
    let eventObject = { 'items' : items };

    sendToDataLayer(eventName, eventObject);
  },
  async add_to_wishlist(viewData, cost, licenseType) {
    let eventName = 'add_to_wishlist';
    let items = [];

    items.push({
      'item_name' : viewData.product_name,
      'item_id' : viewData.product_id,
      'price' : cost,
      'item_category': viewData.product_category,
      'item_variant' : licenseType,
      'quantity' : 1
    });
    let eventObject = { 'items' : items };

    sendToDataLayer(eventName, eventObject);
  },
  async aibegin_checkout(list = []) {
    let eventName = 'begin_checkout';
    let items = [];
    let costs = document.querySelectorAll('.basket-item-cost');
    let value = 0;

    if(list.length === 0) return;

    list.forEach(function(prd){
      items.push({
        'item_name' : prd.img_name,
        'item_id' : prd.idx,
        //'item_category': prd.product_category,
        'item_variant' : prd.cart_product_license,
        'quantity' : 1
      });
    });

    costs.forEach(function(cost, idx){
      let price = cost.innerText.replace(/[^\d.]/g, "");
      items[idx].price = price;
      value += Number(price);
    });

    let eventObject = { 'items' : items, 'value' : value};
    
    window.localStorage.setItem('hurdlers_ga4_items', JSON.stringify(items));
    window.localStorage.setItem('hurdlers_ga4_value', JSON.stringify(value));

    sendToDataLayer(eventName, eventObject);
  },
  async begin_checkout(list = []) {
    let eventName = 'begin_checkout';
    let items = [];
    let costs = document.querySelectorAll('.basket-item-cost');
    let value = 0;

    if(list.length === 0) return;

    list.forEach(function(prd){
      items.push({
        'item_name' : prd.product.product_name,
        'item_id' : prd.product.product_id,
        //'item_category': prd.product_category,
        'item_variant' : prd.cart_product_license,
        'quantity' : 1
      });
    });

    costs.forEach(function(cost, idx){
      let price = cost.innerText.replace(/[^\d.]/g, "");
      items[idx].price = price;
      value += Number(price);
    });

    let eventObject = { 'items' : items, 'value' : value};
    
    window.localStorage.setItem('hurdlers_ga4_items', JSON.stringify(items));
    window.localStorage.setItem('hurdlers_ga4_value', JSON.stringify(value));

    sendToDataLayer(eventName, eventObject);
  },
  async purchase(orderId, amount) {
    let eventName = 'purchase';
    let items = JSON.parse(window.localStorage.getItem('hurdlers_ga4_items'));
    
    let eventObject = { 
      'transaction_id': orderId,
      'items' : items,
      'value' : amount
    };

    window.localStorage.removeItem('hurdlers_ga4_items');
    window.localStorage.removeItem('hurdlers_ga4_value');

    sendToDataLayer(eventName, eventObject);
  }
}